// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1Tvs3","title":"Images90_title__37eN7","images":"Images90_images__2419j"};